// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_babel_polyfill_lib_index_js-node_modules_axios_index_js-node_modules_dow-e8c9a3","js_src_preact-components_eager_recursive_tsx_exclude_server_7C_spec_7Ctest_tsx_7Csettings_7Ct-d711f1"], () => (__webpack_require__("./js/src/libs/preact-entry.tsx")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
